export default {

    s2ab(string) {
        var buffer = new ArrayBuffer(string.length);
        var view = new Uint8Array(buffer);

        for (var i = 0; i != string.length; ++i) {
            view[i] = string.charCodeAt(i) & 0xFF;
        }

        return buffer;
    },

    msToSeconds(milliseconds) {
        return Math.floor(milliseconds / 1000)
    },

    formatResponseErrors(response) {
        let error_str = response && response.body && response.body.message || 'Error caught';

        if (response.body.errors) {
            error_str += ":\n" + response.body.errors.join("\n");
        }
        
        return error_str;
    },


    putTextInClipboard(textContent) {
        let offsetY = window.pageYOffset;
        
        // create hidden text element, if it doesn't already exist
        let targetId = "_hiddenCopyText_";

        // must use a temporary form element for the selection and copy
        let target = document.createElement("textarea");
        target.style.position = "absolute";
        target.style.left = "-9999px";
        target.id = targetId;
        document.body.appendChild(target);

        target.textContent = textContent;

        // select the content
        target.focus();
        target.setSelectionRange(0, target.value.length);

        // copy the selection
        let succeed;
        try {
            succeed = document.execCommand("copy");
        } catch(e) {
            succeed = false;
        }

        $(window).scrollTop(offsetY);

        // remove temporary textarea
        target.remove();

        return succeed;
    },

}